import { __read, __spread } from "tslib";
import { formatValue as valueFormatter, calculateTotalValue, } from '@keen.io/charts-utils';
import { KEEN_KEY, KEEN_TABLE_INTERVAL } from '@keen.io/parser';
import { calculatePercent } from '../../utils';
import { COLUMN_JOIN, VALUE, PERCENTAGE_VALUE } from '../../constants';
export var categoricalChronologicalTransformation = function (data, keys, formatValue, dataSeriesGroups, includePercentageStack) {
    var columns = __spread([
        KEEN_TABLE_INTERVAL,
        dataSeriesGroups.join(COLUMN_JOIN),
        VALUE
    ], (includePercentageStack ? [PERCENTAGE_VALUE] : []));
    var rows = [];
    data.forEach(function (item) {
        var dataSeriesTotal = calculateTotalValue([item], KEEN_KEY, keys);
        rows.push.apply(rows, __spread(keys.map(function (keyName) { return __spread([
            item[KEEN_KEY],
            keyName,
            valueFormatter(item[keyName], formatValue)
        ], (includePercentageStack && item[keyName]
            ? [calculatePercent(item[keyName], dataSeriesTotal) + "%"]
            : [])); })));
    });
    return __spread([columns], rows);
};
